import { Component } from 'vue-property-decorator'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import QuotesList from '@/modules/Quote/scripts/quotes-list'

@Component({})
export default class RelatedQuotesList extends QuotesList {
  breadcrumbs: Breadcrumb[] = []

  caseId: number | null = null
  accountId: number | null = null
  contactId: number | null = null
  carrierProductId: number | null = null
  producerId: number | null = null

  pageType = ''

  ifRelatedList = true

  beforeMount () {
    this.setBreadcrumbs()
    this.filter = {
      caseId: this.caseId,
      contactId: this.contactId,
      accountId: this.accountId,
      carrierProductId: this.carrierProductId,
      producerId: this.producerId,
      isCaseRelated: this.pageType === 'relatedQuote'
    }
    this.storePage()
  }

  async mounted () {
    this.pageType = this.$route.params.type
  }

  setBreadcrumbs () {
    const { fromName, id } = this.$route.params
    switch (this.$route.name) {
      case 'AccountRelatedQuotesList':
        this.accountId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Accounts',
            to: { name: 'AccountsList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'AccountDetailQuotes',
            params: {
              id: id
            }
          }
        })
        break
      case 'CaseRelatedQuotesList':
        this.caseId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Case',
            to: { name: 'CaseDashboard' }
          }
        )
        this.breadcrumbs.push({
          text: fromName
            ? `${fromName} (Case ID: ${id})`
            : id,
          to: {
            name: 'CaseDetailQuotes',
            params: {
              id: id
            }
          }
        })
        break
      case 'ContactRelatedQuotesList':
        this.contactId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Contacts',
            to: { name: 'ContactList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'ContactDetailQuotes',
            params: {
              id: id
            }
          }
        })
        break
      case 'CarrierProductRelatedQuotesList':
        this.carrierProductId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Insurance Products',
            to: { name: 'CarrierProductList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'CarrierProductDetailQuotes',
            params: {
              id: id
            }
          }
        })
        break
      case 'ProducerRelatedQuotesList':
        this.producerId = Number(id)
        this.breadcrumbs.push(
          {
            text: 'Producers',
            to: { name: 'ProducerList' }
          }
        )
        this.breadcrumbs.push({
          text: fromName || id,
          to: {
            name: 'ProducerDetailQuotes',
            params: {
              id: id
            }
          }
        })
        break
      default:
        break
    }
    this.breadcrumbs.push({
      text: 'quotes'
    })
  }
}
